import { LOG_LEVELS, LogLevel } from './types';

export function isLogLevelEnabled(
  level: LogLevel,
  minLevel: LogLevel
): boolean {
  return LOG_LEVELS.indexOf(level) >= LOG_LEVELS.indexOf(minLevel);
}
